import {
  House,
  Tag,
  Receipt,
  Ticket,
  User,
  Star,
  ChartBar,
  CreditCard,
  Storefront,
} from '@phosphor-icons/react'

const menu = [
  {
    title: 'MENU & ORDERS',

    items: [
      {
        label: 'Dashboard',
        path: '/',
        icon: House,
      },

      {
        label: 'Catalog',
        path: '/catalog',
        icon: Tag,
      },

      {
        label: 'Orders',
        path: '/orders',
        icon: Receipt,
        badge: 5,
      },
    ],
  },

  {
    title: 'LOYALTY & PROMOTIONS',

    items: [
      {
        label: 'Vouchers & Promo Code',
        path: '/vouchers',
        icon: Ticket,
      },

      // {
      //   label: 'Points Management',
      //   path: '/points-management',
      //   icon: Star,
      // },
    ],
  },

  {
    title: 'CUSTOMERS',

    items: [
      {
        label: 'Customers',
        path: '/customers',
        icon: User,
      },

      // {
      //   label: 'Points Management',
      //   path: '/points-management',
      //   icon: Star,
      // },
    ],
  },

  {
    title: 'ANALYTICS & SETTINGS',

    items: [
      {
        label: 'Sales Reporting',
        path: '/sales-reporting',
        icon: ChartBar,
      },

      {
        label: 'Payment Config',
        path: '/payment-config',
        icon: CreditCard,
      },
      {
        label: 'Staff',
        path: '/staff',
        icon: User,
      },

      {
        label: 'Role',
        path: '/roles',
        icon: CreditCard,
      },

      {
        label: 'Outlet Setup',
        path: '/outlet-setup',
        icon: Storefront,
      },
    ],
  },
]

export default menu